import { useMemo } from 'react'
import { useRouter } from 'expo-router'
import { ScrollView, View } from 'react-native'
import { useQuery } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'
import { createComponent } from 'react-native-small-ui'
import { StyleSheet } from 'react-native'
import { GamesEmptyMessage, YourGameCard } from '@/screens/play-screen/Sections/YourGames'
import { useStore } from '@/models'
import { DS } from '../../../../design-system'
import { monthDayAndTimeFormatter } from '../../../../utils'
import game from '../../../../../router/(root)/game'

const Box = createComponent(View, {
  flexGrow: 1
})

export const YourConvexGames = () => {
  const router = useRouter()

  const { user } = useStore().session
  const userId = user?.auth0Id || 'guest'

  const playingGames = useQuery(api.metadata.queries.listMyGames, { userId, state: 'playing' })
  const pregameGames = useQuery(api.metadata.queries.listMyGames, { userId, state: 'pregame' })
  const gameList = useMemo(() => {
    const myGames = [...(playingGames ?? []), ...(pregameGames ?? [])]
      .filter((g) => g.mode !== 'daily10' && g.mode !== 'mtt')
      .sort((a, b) => b.lastActivityAt - a.lastActivityAt)

    return myGames
  }, [playingGames, pregameGames])

  if (!gameList?.length) return undefined

  return (
    <View style={containerStyles.webWrapper}>
      <DS.Frame gap="12" style={{ marginHorizontal: -DS.spacing[24] }}>
        <DS.Text style={{ paddingHorizontal: 24 }} variant="Heading 3/Medium">
          Your Games {gameList.length > 2 ? `(${gameList.length})` : ''}
        </DS.Text>
        {gameList?.length === 0 && (
          <Box style={{ paddingHorizontal: 24 }}>
            <GamesEmptyMessage />
          </Box>
        )}
        {gameList && (
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            contentContainerStyle={{ paddingHorizontal: 24 }}
          >
            <DS.Frame row gap="8">
              {gameList?.map((data, i) => (
                <YourGameCard
                  key={`your-live-game-${data.name}-${i}`}
                  tableName={monthDayAndTimeFormatter(new Date(data?.startedAt || Math.trunc(data._creationTime)))}
                  pattern={i}
                  onPress={() => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    router.navigate({ pathname: '/game/[gameId]', params: { gameId: data.gameId } } as any)
                  }}
                  // Custom for Convex practice games
                  context="convex"
                  isPractice={data.mode === 'practice'}
                  gameState={data.state}
                  gameMode={data.mode}
                  blinds={[]} // TODO for tournaments
                  seats={[data.playerCount - 1, 10]} // TODO where is this magic number 10 seats
                />
              ))}
            </DS.Frame>
          </ScrollView>
        )}
      </DS.Frame>
    </View>
  )
}

const containerStyles = StyleSheet.create({
  webWrapper: {
    width: '100%',
    maxWidth: 600,
    alignSelf: 'center'
  },
  webWrapperExtended: {
    width: '100%',
    maxWidth: 900,
    alignSelf: 'center'
  }
})
